module.exports = __webpack_public_path__ + "img/BSLC_LOGO_B 1.1f2187ac.png";